let $ = require("jquery");
let _ = require("underscore");
import POS from "../POS.js";
import TooieStatusService from "./TooieStatusService"
import PrintService from './PrintService.js';

let main = function () {
    var CloudPrintUtils = {
        // 云打印方法
        _cloudPrint: function (payload, billId) {
            if (!POS.getUseCloudPrint()) {
                return;
            }
            $.post("/pos/print", {
                payload: JSON.stringify(payload),
                restaurantId: POS.getRestaurant().id,
                billId: billId
            }).fail(function (response, xhr) {
                PrintService.getPrinterStatus().set({offline: true});
                console.warn(new Date() + " unable to relay print request to cloud print server: ", xhr.status);
                TooieStatusService.statusModel().set({'status': 'PrintError'});
            });
        }
    };
    return CloudPrintUtils;
};
let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/service/CloudPrintUtils.js